import { DEFAULT_RESULT_LANGUAGE, LANGUAGES, normalizeLanguageValue } from "@/lib/constants/languages";

export function resolveInitialToolLanguage(opts: {
  a11yLanguage?: string | null;
  userSettings?: any;
  fallback?: string;
}): string {
  const { a11yLanguage, userSettings, fallback = DEFAULT_RESULT_LANGUAGE } = opts;
  const raw =
    userSettings?.resultLanguage ||
    userSettings?.displayLanguage ||
    a11yLanguage ||
    fallback;
  const normalized = normalizeLanguageValue(raw);
  return (normalized || fallback) as string;
}

export function isKnownLanguage(value?: string | null): boolean {
  if (!value) return false;
  return Object.values(LANGUAGES).includes(value as LANGUAGES);
}
